import { css } from '@emotion/css';

export const fieldSettingsSectionStyles = (spacing = 0) => css`
  padding: 0;
  margin: 0;
  box-shadow: none;

  .form-field + .form-field {
    margin-top: ${spacing}px;
  }

  .form-field .MuiSwitch-root {
    margin-inline-end: 0.8rem;
  }
`;
